import type { Zone } from '../../../models';

export const canDeleteSavedPolygon = (zone: Zone): boolean =>
  zone.isPolygon === true;
